<template>
  <div class="big">
    <ImportData
      :isFlag="importdata"
      @refreshList="getList"
    ></ImportData>
    <div class="page_title">业务员奖励通知管理</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>奖励月份</span>
            <el-date-picker
              v-model="month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              style="margin-left: 6px; width: 140px"
              @change="search"
              clearable
            ></el-date-picker>
          </div>
          <div class="item">
            <span>大区</span>
            <el-input
              placeholder="请输入"
              v-model="area_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工工号</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_code"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工姓名</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工手机号</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981; margin-left: 6px"
              @click="search"
            >查询</el-button>
          </div>
        </div>
        <div class="pricebox">
          <div class="price">
            <div
              class="priceitem"
              style="width:140px"
            >
              <div
                class="num"
                style="color: #333"
              >{{ current_time }}</div>
            </div>
            <div
              class="priceitem"
              style="width:140px"
            >
              <div class="num">{{ count }}</div>
              <div class="gray">奖励员工数</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ total_reward_total_money }}</div>
              <div class="gray">奖励合计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ total_reward_money }}</div>
              <div class="gray">大客户奖励合计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ total_reward_excess_money }}</div>
              <div class="gray">超额订单奖合计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ total_reward_increase_money }}</div>
              <div class="gray">个人增长奖合计</div>
            </div>
            <div
              class="priceitem"
              style="width:80px"
            >
              <div
                class="notpush"
                v-if="is_push==0"
              >未推送</div>
              <div
                class="push"
                v-if="is_push==1"
              >已推送</div>
            </div>
          </div>
          <span>
            <el-button
              v-if="is_push==0"
              type="primary"
              @click="pushMsg"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('1046') : false
        "
            >推送通知</el-button>
            <el-button
              type="primary"
              @click="addData"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('1045') : false
        "
            >导入任务</el-button>
            <el-button
              @click="deldata=true;del_month=''"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('1044') : false
        "
            >删除任务</el-button>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="大区"
              prop="area_name"
            >
            </el-table-column>
            <el-table-column
              label="员工号"
              prop="recommender_code"
            >
            </el-table-column>
            <el-table-column
              label="员工姓名"
              prop="recommender_name"
            >
            </el-table-column>
            <el-table-column
              label="员工手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="大客户奖励"
              prop="reward_money"
            ></el-table-column>
            <el-table-column
              label="超额订单奖(不含大客户)"
              prop="reward_excess_money"
            ></el-table-column>
            <el-table-column
              label="个人增长奖（含大客户）"
              prop="reward_increase_money"
            ></el-table-column>
            <el-table-column
              label="奖励合计"
              prop="reward_total_money"
            >
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 0 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 删除任务 -->
    <el-dialog
      title="请选择删除任务月份"
      :visible.sync="deldata"
      width="360px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div style="padding:30px 40px">
        <div>
          <span>任务月份</span>
          <el-date-picker
            v-model="del_month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="margin-left: 6px;width: 200px"
            clearable
            @change="changeDelMonth"
          ></el-date-picker>
        </div>
        <div style="text-align:center;margin-top:40px">
          <el-button
            type="primary"
            size="mini"
            @click="delMonth"
          >确认</el-button>
          <el-button
            plain
            size="mini"
            @click="deldata=false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import ImportData from './ImportData.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      phone: '',
      recommender_code: '',
      recommender_name: '',
      month: '',
      area_name: '',
      is_stand: 0,
      current_time: '',
      importdata: false,
      deldata: false,
      del_month: '',
      is_push: 0,
      count: 0,
      total_reward_total_money: 0,
      total_reward_money: 0,
      total_reward_increase_money: 0,
      total_reward_excess_money: 0
    };
  },
  components: {
    ImportData
  },
  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format('YYYY-MM');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      if (!this.month) {
        this.$message.error('请选择任务月份');
        return false;
      }
      this.current_time = dayjs(this.month).format('YYYY年MM月');
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        month: this.month,
        area_name: this.area_name,
        phone: this.phone,
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name
      };
      this.axios
        .post('platform/Staff/recommenderRewardList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.reward_money = item.reward_money
                ? Number(item.reward_money)
                : '';
              item.reward_excess_money = item.reward_excess_money
                ? Number(item.reward_excess_money)
                : '';
              item.reward_increase_money = item.reward_increase_money
                ? Number(item.reward_increase_money)
                : '';
              return item;
            });
            this.count = res.data.count;
            this.total_reward_total_money = res.data.total_reward_total_money;
            this.total_reward_money = res.data.total_reward_money;
            this.total_reward_increase_money =
              res.data.total_reward_increase_money;
            this.total_reward_excess_money = res.data.total_reward_excess_money;
            this.is_push = res.data.is_push ? res.data.is_push : 0;
            this.totalNum = res.data.total;
          }
        });
    },
    //查看详情
    toDetail(recommender_code) {
      this.$router.push({
        path: 'salesmandetail',
        query: {
          recommender_code,
          month: this.month
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },
    //删除改变月份
    changeDelMonth(month) {
      if (month) {
        this.axios
          .post('platform/Staff/recommenderRewardCount', { month })
          .then((res) => {
            if (res.code == 0) {
              if (res.data.info.count == 0) {
                this.$alert('该月任务不存在,请重新选择', '提示', {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.del_month = '';
                  }
                });
              }
            }
          });
      }
    },
    delMonth() {
      if (!this.del_month) {
        this.$message.error('请选择删除任务的月份');
        return false;
      }
      let month = this.del_month;
      this.axios
        .post('platform/staff/delRecommenderReward', { month })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.deldata = false;
            this.getList();
          }
        });
    },
    //推送通知
    pushMsg() {
      if (!this.tableData.length) {
        this.$message.error('暂无可推送数据');
        return false;
      }
      this.$confirm(
        '请您再次确认数据，提交后将会给对应人员推送奖励消息',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          let month = this.month;
          this.axios
            .post('platform/Staff/sendRecommenderRewardMsg', { month })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('已推送通知');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.month = dayjs(new Date()).format('YYYY-MM');
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 14px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 20px 0;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      width: 160px;
      border-right: solid 1px #e1e3e9;
      .notpush {
        font-size: 17px;
        font-weight: 600;
        color: #f24e33;
      }
      .push {
        font-size: 17px;
        font-weight: 600;
        color: #669961;
      }
    }
    .priceitem:before {
      content: '';
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
</style>